export const PaymentMethodsTypes = {
  BANK_TRANSFER: 'bank_transfer',
  GP_BOLETO: 'gp_boleto',
  GP_PAYPAL: 'gp_paypal',
  PAYPAL: 'paypal',
  BRASPAG_CREDIT: 'braspag_credit',
  DLOCAL: 'dlocal',
  QR_PAYMENT: 'qr_payment',
  EFECTIVE_PAYMENT: 'cash_payment',
  WALLET: 'wallet',
  PIX: 'gp_pix',
  PAYU_BOLETO: 'payu_boleto',
  CURRENT_CREDIT_CARD: 'current_credit_card',
};

export const PaymentMethodsKey = {
  CURRENT_CREDIT_CARD: 'current_credit_card',
};

export const PaymentStatusTypes = {
  SUCCESS_GENERIC: 'SUCCESS_GENERIC',
  FAILURE_CREDIT_CARD: 'FAILURE_CREDIT_CARD',
  PIX_TIME_EXPIRED: 'PIX_TIME_EXPIRED',
  PIX_ONGOING: 'PIX_ONGOING',
  ERROR_GENERIC: 'ERROR_GENERIC',
  FOLLOW_NEW_TAB_INSTRUCTIONS: 'FOLLOW_NEW_TAB_INSTRUCTIONS',
  GENERIC_FAILURE: 'GENERIC_FAILURE',
};

export const PAYMENT_MODAL_CALLER = {
  INVOICES_MANAGER: 'INVOICES_MANAGER',
  SUBSCRIPTION_LIST: 'SUBSCRIPTION_LIST',
  SUBSCRIPTION_MANAGER: 'SUBSCRIPTION_MANAGER',
  SITELOCK_UPGRADE: 'SITELOCK_UPGRADE',
};

export const PaypalActionTypes = {
  CALLING_BY_SWITCH_PAYMENT_METHOD_MODAL: 'payment_method_modal_by_subscriptions',
  CALLING_BY_PAYMENT_MODAL: 'payment_modal_by_manager_subscriptions',
  CALLING_BY_MANAGER_INVOICES: 'payment_modal_by_manager_invoices',
  CALLING_BY_LIST_SUBSCRIPTIONS: 'payment_modal_by_list_subscriptions',
};

export const PAYMENT_STATUS = {
  FAIL: 'paymentFail',
  SUCCESS: 'paymentSuccess',
  HIDDEN: 'paymentHidden',
  PENDING_ANALYSIS: 'pendingAnalysis',
};

export const CALLER = {
  SUBSCRIPTIONS: 'subscriptions',
  INVOICES: 'invoices',
  SITELOCK: 'sitelock',
  FASTCHECKOUT: 'fastcheckout',
};
